import * as React from 'react';

interface IProps {
    active: number
}

export function IconCarousel(props: IProps) {
    return (
        <svg width={20} height={20} viewBox="0 0 20 20" >
            <path
                data-name="View Carrousel copy 2"
                d="M.5.5h19v12H.5V.5zm0 14h5v5h-5v-5zm7 0h5v5h-5v-5zm7 0h5v5h-5v-5z"
                fill="none"
                stroke={props.active ? '#2aaef5' : '#999'}
            />
        </svg>
    );
}




// WEBPACK FOOTER //
// ./src/Pages/PhotoViewer/IconCarousel.tsx